import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PolicyService } from 'app/services/policy-service';
import { ChatService } from 'app/services/chat-service';

export interface QuickAction {
    iconKey: string;
    title: string;
    desc: string;
    link: string;
}

// Producto DJ29 (Asistencia Jurídica Familiar) del cliente, tal y como se muestra en el
// desplegable del modal de chat: nombre del producto (combinationDescription) + código
// (número de póliza).
interface LegalAssistanceProduct {
    name: string;
    code: string;
}

@Component({
    selector: 'app-quick-actions',
    templateUrl: './quick-actions.component.html',
    styleUrls: ['./quick-actions.component.scss']
})
export class QuickActionsComponent {

    @Input() userName: string = '';
    @Input() actions: QuickAction[] = [];
    @Input() showQuickActions: boolean = true;

    // Estado del modal "Chat con abogado" que se abre desde la acción rápida de chat.
    chatModalOpen = false;
    loadingProducts = false;
    products: LegalAssistanceProduct[] = [];
    selectedProductCode: string = '';


    constructor(
        private router: Router,
        private policyService: PolicyService,
        private chatService: ChatService,
        private toastr: ToastrService) {}

    irA(action: QuickAction): void {
        // "Chatea con un abogado" abre un modal para elegir sobre qué producto DJ29 consultar
        // antes de lanzar el chat (Aunoa), en vez de navegar.
        if (action.iconKey === 'chat') {
            this.openChatModal();
            return;
        }
        this.router.navigate([action.link]);
    }

    private openChatModal(): void {
        this.chatModalOpen = true;
        this.selectedProductCode = '';
        this.loadProducts();
    }

    // Las pólizas DJ29 (Asistencia Jurídica Familiar) del usuario son los productos sobre los
    // que se puede consultar con un abogado. De cada póliza se muestra la descripción del
    // producto y su número.
    private loadProducts(): void {
        this.loadingProducts = true;
        this.policyService.getLegalAssistancePolicies()
            .then((list: any[]) => {
                this.products = (list || []).map(p => ({
                    name: p.product || p.number,
                    code: p.number
                }));
                this.loadingProducts = false;
            })
            .catch(() => {
                this.products = [];
                this.loadingProducts = false;
                this.toastr.error('No se han podido cargar los productos.', 'Error de conectividad', { timeOut: 5000 });
            });
    }

    closeChatModal(): void {
        this.chatModalOpen = false;
    }

    // El botón "Chatea con un abogado" solo se habilita cuando hay un producto seleccionado.
    // El contexto de la póliza se envía al bot al abrir el chat, no al elegir el producto.
    confirmChat(): void {
        if (!this.selectedProductCode) { return; }
        this.chatModalOpen = false;
        this.chatService.openChatWithContext(this.selectedProductCode);
    }
}
